function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group-10375"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 2.79078L0 14.5665C0 16.1078 1.25741 17.3573 2.80844 17.3573C4.35947 17.3573 5.61688 16.1078 5.61688 14.5665L5.61688 2.79078C5.61688 1.24938 4.35947 0 2.80844 0C1.25741 0 0 1.2495 0 2.79078Z",
  transform: "translate(0 14.583984)",
  id: "Vector",
  fill: "#FFFFFF",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 2.79078L0 14.5665C0 16.1078 1.25741 17.3573 2.80844 17.3573C4.35947 17.3573 5.61687 16.1078 5.61687 14.5665L5.61687 2.79078C5.61687 1.24938 4.35947 0 2.80844 0C1.25741 0 0 1.2495 0 2.79078Z",
  transform: "translate(32.810547 14.583984)",
  id: "Vector",
  fill: "#E6E6E6",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.5566 1.05479L19.7969 0.000118158L17.652 3.53369C16.1122 2.86999 14.4136 2.50137 12.6281 2.50137C10.8426 2.50137 9.14403 2.86987 7.60418 3.53369L5.45936 0L3.69966 1.05467L5.78975 4.49804C2.4269 6.6529 0.159065 10.35 0 14.5834L25.2561 14.5834C25.0971 10.35 22.8293 6.6529 19.4665 4.49804L21.5566 1.05479ZM5.62414 8.54246C5.62414 7.83761 6.19913 7.26624 6.90843 7.26624C7.61774 7.26624 8.19273 7.83761 8.19273 8.54246C8.19273 9.24719 7.61774 9.81868 6.90843 9.81868C6.19913 9.81868 5.62414 9.2473 5.62414 8.54246ZM16.9264 8.54246C16.9264 7.83761 17.5014 7.26624 18.2107 7.26624C18.92 7.26624 19.495 7.83761 19.495 8.54246C19.495 9.24719 18.92 9.81868 18.2107 9.81868C17.5014 9.81868 16.9264 9.2473 16.9264 8.54246Z",
  transform: "translate(6.654297 0)",
  id: "Vector",
  fill: "#FFFFFF",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.95736 1.05467L7.19766 0L5.05272 3.53358C3.51287 2.86987 1.81432 2.50125 0.0287916 2.50125C0.0191549 2.50125 0.00963669 2.5016 0 2.5016L0 14.5833L12.6569 14.5833C12.498 10.3499 10.2301 6.65278 6.86727 4.49792L8.95736 1.05467ZM4.32723 8.54234C4.32723 7.83749 4.90222 7.26612 5.61153 7.26612C6.32084 7.26612 6.89583 7.83749 6.89583 8.54234C6.89583 9.24719 6.32084 9.81856 5.61153 9.81856C4.90222 9.81856 4.32723 9.24719 4.32723 8.54234Z",
  transform: "translate(19.25293 0)",
  id: "Vector",
  fill: "#E6E6E6",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.00037 19.6036L5.00037 25.8318C5.00037 27.3731 6.25778 28.6226 7.80881 28.6226C9.35984 28.6226 10.6173 27.3731 10.6173 25.8318L10.6173 19.6036L14.5217 19.6036L14.5217 25.8318C14.5217 27.3731 15.7791 28.6226 17.3301 28.6226C18.8811 28.6226 20.1385 27.3731 20.1385 25.8318L20.1385 19.6036L25.276 19.6036L25.276 0L0 0L0 19.6036L5.00037 19.6036Z",
  transform: "translate(6.5751953 16.456055)",
  id: "Vector",
  fill: "#FFFFFF",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 19.6036L1.84406 19.6036L1.84406 25.8318C1.84406 27.3731 3.10147 28.6226 4.6525 28.6226C6.20353 28.6226 7.46094 27.3731 7.46094 25.8318L7.46094 19.6036L12.5984 19.6036L12.5984 0L0 0L0 19.6036Z",
  transform: "translate(19.25293 16.456055)",
  id: "Vector",
  fill: "#E6E6E6",
  fillRule: "evenodd",
  stroke: "none"
}));

var SvgAndroid = function SvgAndroid(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "47px",
    height: "56px",
    viewBox: "0 0 47 56",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAndroid, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/android.da62c51d.svg";
export { ForwardRef as ReactComponent };